// + ToDo
// Priority 1: Clean Document State
// Eventually reduce to:
// const [selectedRole, setSelectedRole] = useState(null);
// const [activeDocument, setActiveDocument] = useState(null); // CERTIFICATE | AGREEMENT
// const [showDocument, setShowDocument] = useState(true);
// Everything can be derived from these 3 states.
// riority 2: Agreement PDF Professionalization
// + Company Logo
// + Gold Header
// + Agreement Number
// + Issue Date
// + Expiry Date
// + QR Verification
// + User Signature Block
// + Company Signature Block
// + Watermark
// Priority 3: Influencer Agreement
// Priority 4: Agreement Acceptance
// Priority 5: Agreement Versioning
// Agreement Acceptance + MongoDB storage
// QR Verification Page
// Professional agreement styling
// Document Center

const COMPANY = {
  name: "Think5Whys Global DeepTech Solutions Private Limited",
  website: "www.think5whys.com",
  city: "Mumbai",
  country: "India",
  cin: "A45775433789",
};

export const generateAgreement = ({
  role,
  userName,
  userCode,
  city,
  state,
  country,
  pincode,
}) => {
  const today = new Date();

  const startDate = today.toLocaleDateString("en-IN");

  const endDate = new Date(
    today.getFullYear() + 1,
    today.getMonth(),
    today.getDate()
  ).toLocaleDateString("en-IN");

  const location = [
    city,
    state,
    country,
    pincode,
  ]
    .filter(Boolean)
    .join(", ");

  if (role === "DIRECTOR") {
    return {
      title: "Director Partner Agreement",
      role,
      startDate,
      endDate,

      content: `
THIS DIRECTOR PARTNER AGREEMENT ("Agreement") is entered into on ${startDate}
between ${COMPANY.name}, Mumbai, India ("Company")
and ${userName} (${userCode}) ("Director Partner").

1. APPOINTMENT
The Company appoints the Director Partner as an authorised business
representative within the Think5Whys ecosystem.

2. RESPONSIBILITIES
• Build and support business growth.
• Guide Coordinators and Influencers.
• Promote ethical business conduct.
• Protect Company reputation and intellectual property.

3. NON-EXCLUSIVITY
This appointment is non-exclusive and does not constitute employment.

4. CONFIDENTIALITY
The Director Partner shall not disclose confidential business information,
platform data, pricing structures, strategies, or customer information.

5. BRAND USAGE
The Director Partner may use approved Think5Whys branding strictly
for authorised business activities.

6. COMPLIANCE
The Director Partner shall comply with all applicable laws and Company policies.

7. TERM
This Agreement shall remain valid from ${startDate}
until ${endDate}, unless terminated earlier.

8. TERMINATION
The Company may revoke this Agreement in case of misconduct,
fraudulent activity, policy violations, or reputational damage.

9. LIMITATION OF LIABILITY
The Company shall not be liable for indirect, incidental,
or consequential losses arising from Partner activities.

10. ACCEPTANCE
By accepting this Agreement, both parties acknowledge
their understanding and acceptance of these terms.

Partner Location:
${location}

Company:
${COMPANY.name}
${COMPANY.website}
CIN: ${COMPANY.cin}
      `,
    };
  }

  return {
    title: "Coordinator Partner Agreement",
    role,
    startDate,
    endDate,

    content: `
THIS COORDINATOR PARTNER AGREEMENT ("Agreement") is entered into on ${startDate}
between ${COMPANY.name}, Mumbai, India ("Company")
and ${userName} (${userCode}) ("Coordinator Partner").

1. APPOINTMENT
The Company appoints the Coordinator Partner as an authorised coordinator
within the Think5Whys ecosystem.

2. RESPONSIBILITIES
• Coordinate business activities.
• Support Directors and Influencers.
• Maintain professional communication.
• Assist customer onboarding and engagement.

3. NON-EXCLUSIVITY
This appointment is non-exclusive and does not constitute employment.

4. CONFIDENTIALITY
The Coordinator Partner shall maintain confidentiality of all
Company information and customer data.

5. BRAND USAGE
Only approved Company branding may be used.

6. COMPLIANCE
The Coordinator Partner agrees to comply with all Company policies.

7. TERM
This Agreement shall remain valid from ${startDate}
until ${endDate}, unless terminated earlier.

8. TERMINATION
The Company reserves the right to revoke this Agreement
for misconduct or policy violations.

9. LIMITATION OF LIABILITY
The Company shall not be liable for indirect or consequential losses.

10. ACCEPTANCE
Both parties agree to the terms stated herein.

Partner Location:
${location}

Company:
${COMPANY.name}
${COMPANY.website}
CIN: ${COMPANY.cin}
    `,
  };
};